export const PS_TO_CS_STATUS_MAP = {
  'In Storage': {
    status: 'FOLLOWUP',
    color: '#E6BA00'
  },
  'Order Received': {
    status: 'OK',
    color: '#00B966'
  },
  'General Hold': {
    status: 'FOLLOWUP',
    color: '#D10411'
  },
  'Credit Hold': {
    status: 'FOLLOWUP',
    color: '#E6BA00'
  },
  'Partial Shipment': {
    status: 'FOLLOWUP',
    color: '#E6BA00'
  },
  'Proof Hold': {
    status: 'FOLLOWUP',
    color: '#E6BA00'
  },
  'Complete': {
    status: 'OK',
    color: '#00B966'
  },
  'Order Confirmed': {
    status: 'OK',
    color: '#00B966'
  },
  'Pre-Production': {
    status: 'OK',
    color: '#E6BA00'
  },
  'In Production': {
    status: 'OK',
    color: '#00B966'
  },
  'Partially Shipped': {
    status: 'FOLLOWUP',
    color: '#E6BA00'
  },
  'Shipped': {
    status: 'OK',
    color: '#00B966'
  },
  'Canceled': {
    status: 'PROBLEM',
    color: '#D10411'
  },
  'Art Hold': {
    status: 'FOLLOWUP',
    color: '#E6BA00'
  },
  'Back Order Hold': {
    status: 'PROBLEM',
    color: '#D10411'
  },
  'Order Entry Hold': {
    status: 'PROBLEM',
    color: '#D10411'
  }
};

